<template>
  <div class="panel-body">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#">Inicio</a></li>
        <li class="breadcrumb-item active" aria-current="page">Información Personal</li>
      </ol>
    </nav>
    <h1 class="regis">Información Personal</h1>
    <hr class="my-4">
    <h5 class="regiss">Datos Básicos</h5>
    <vue-form-generator :schema="schema" :model="model" ref="newMemberForm" :options="formOptions"></vue-form-generator>

    <div>
    </div>

    <b-alert class="alertared" :show="dismissCountDown" dismissible @dismissed="dismissCountDown = 0"
      @dismiss-count-down="countDownChanged" variant="danger">{{ mensaje }}</b-alert>
    <b-alert class="alertared" :show="disiss" dismissible @dismissed="disiss = 0" @dismiss-count-down="disissDownChanged"
      variant="success">Usuario actualizado exitosamente.</b-alert>

    <div class="centro">
      <div>
        <b-button @click="updateDatosPersonales" class=" botonregidtro"><span v-if="this.load == false"
            class="ingresar poppins-semi-bold-white-14px">Actualizar</span>
          <div v-if="this.load == true"><b-spinner small></b-spinner><span
              class="sr-only ingresar poppins-semi-bold-white-14px">Cargando...</span></div>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import "vue-form-generator/dist/vfg-core.css";
import VueJwtDecode from "vue-jwt-decode";

Vue.use(VueFormGenerator)

const config = RepositoryFactory.get("config");
export default {
  components: {
    "vue-form-generator": VueFormGenerator.component
  },
  data() {
    return {
      dismissSecs: 5,
      dismissCountDown: 0,
      disiss: 0,
      dis: 10,
      load: false,
      company: [],
      pp: "",
      mensaje: "",
      model: {
        pnombre: null,
        snombre: null,
        papellido: null,
        sapellido: null,
        tipo_identificacion: { id: null, name: null },
        identificacion: null,
        country: null,
        celular: null,
        email: null,
        empresa: { id: null, name: null },
        perfil: { id: null, name: null },

      },
      schema: {
        fields: [
          {
            type: 'input',
            inputType: 'text',
            label: 'Primer Nombre',
            model: 'pnombre',
            required: true,
            styleClasses: 'col-md-5 transform:uppercase ',
            max: 70,
            validator: ["required", "string", "alpha"],
            disabled: (model) => {
              return true;
            },
          },
          {
            type: 'input',
            inputType: 'text',
            label: 'Segundo Nombre',
            model: 'snombre',
            required: false,
            max: 70,
            styleClasses: 'offset-md-2 col-md-5',
            validator: ["string", "alpha"],
          },
          {
            type: 'input',
            inputType: 'text',
            label: 'Primer Apellido',
            model: 'papellido',
            required: true,
            max: 70,
            styleClasses: 'col-md-5',
            validator: ["required", "string", "alpha"],
            disabled: (model) => {
              return true;
            },
          },
          {
            type: 'input',
            inputType: 'text',
            label: 'Segundo Apellido',
            model: 'sapellido',
            required: false,
            max: 70,
            styleClasses: ' offset-md-2 col-md-5',
            validator: ["string", "alpha"],

          },
          {
            type: 'select',
            label: 'Tipo ID ',
            model: 'tipo_identificacion.id',
            values: [
              { id: 1, name: 'Cédula de Ciudadanía' },
              { id: 2, name: 'Cédula de Extranjería' },
              { id: 3, name: 'Tarjeta de Identidad' },
              { id: 4, name: 'Registro Civil Temporal' },
              { id: 5, name: 'NUIP' },
              { id: 6, name: 'Certificado Nacido Vivo' },
              { id: 7, name: 'Diplomático,Documento de Identidad de Extranjeros' },
              { id: 8, name: 'ID Fiscal para el Exterior' },
              { id: 9, name: 'Permiso Especial de Permanencia' },
              { id: 10, name: 'Permiso Especial de Permanencia' },
              { id: 11, name: 'Pasaporte' },
              { id: 12, name: 'Pasaporte ONU' },
              { id: 13, name: 'Salvoconducto de Permanencia' },
            ],
            required: true,
            styleClasses: 'col-md-5',
            validator: ["required"],
            disabled: (model) => {
              return true;
            },
            selectOptions: {
              noneSelectedText: 'Seleccione una opción',
            },


          },
          {
            type: 'input',
            inputType: 'text',
            inputName: "N° identificacion",
            label: 'Número de identificación',
            model: 'identificacion',
            required: true,
            readonly: false,
            disabled: false,
            max: 15,
            validator: ["required", "string"],
            styleClasses: 'offset-md-2 col-md-5',
            disabled: (model) => {
              if (model.tipo_identificacion == '' || model.tipo_identificacion == undefined) return true;
              return false;
            },
            visible: function (model) {
              //visible if business is selected
              return model.tipo_identificacion == 'Cédula de Extranjería';
            }
          },
          {
            type: 'input',
            inputType: 'number',
            inputName: "identificacion",
            label: 'Número de identificación',
            model: 'identificacion',
            required: true,
            readonly: false,
            disabled: false,
            max: 999999999999999,
            validator: ["required", "number"],
            styleClasses: 'offset-md-2 col-md-5',
            disabled: (model) => {
              if (model.tipo_identificacion == '' || model.tipo_identificacion == undefined) return true;
              return false;
            },
            visible: function (model) {
              return model.tipo_identificacion != 'Cédula de Extranjería';
            }
          },


          {
            type: "select",
            label: "Celular",
            model: "country",
            values: ['+1', '+51', '+52', '+54', '+55', '+56', '+57', '+58', '+591', '+592', '+593', '+594'],
            styleClasses: 'col-md-1',
            validator: ["required"],
            required: true,
            selectOptions: {
              noneSelectedText: 'Seleccione una opción',

            },

          },
          {
            type: 'input',
            label: '',
            id: "phone",
            inputType: 'text',
            model: 'celular',
            max: 10,
            styleClasses: 'col-md-4',
            validator: ["required", "string"],
          },
          {
            type: 'input',
            inputType: 'email',
            label: 'Correo Electrónico',
            model: 'email',
            max: 100,
            required: true,
            styleClasses: 'offset-md-2 col-md-5',
            validator: ["required", "email"],
          },
          {
            type: 'select',
            label: 'Perfil ',
            model: 'perfil.id',
            values: [],
            required: true,
            styleClasses: 'col-md-5',
            validator: ["required"],
            // disabled: (model) => {
            //   if (model.empresa == '' || model.empresa == undefined) return true;
            //   return false;
            // },
            disabled: (model) => {
              return true;
            },
            selectOptions: {
              noneSelectedText: 'Seleccione una opción',

            },
          },
          {
            type: 'select',
            label: 'Empresa',
            model: 'empresa.id',
            values: [
              { id: 1, name: 'Cielum' },
              { id: 2, name: 'SURA' },
              { id: 3, name: 'Químico FarmacéuticoComfama' },
              { id: 4, name: 'Janssen' },],

            required: true,
            disabled: (model) => {
              return true;
            },
            styleClasses: 'offset-md-2 col-md-5',
            validator: ["required"],
            selectOptions: {
              noneSelectedText: 'Seleccione una opción',

            },
          },



        ]
      },
      formOptions: {

        validateAfterLoad: false,
        validateAfterChanged: true,
        validateAsync: false,
        validationErrorClass: "has-error",
        validationSuccessClass: "has-success",
      },


    }
  },
  mounted() {

    let elem = document.getElementById('identificacion');
    elem.addEventListener("keypress", function (event) {
      const key = event.key;
      if (/[a-zA-Z0-9]/.test(key)) { } else {
        return event.preventDefault();
      }
    });
    elem.addEventListener('input', function () {
      if (this.value.length > 15)
        this.value = this.value.slice(0, 15);
    });
    let nombre = document.getElementById('primer-nombre');
    nombre.addEventListener("keypress", function (event) {
      const key = event.key;
      if (/[a-zA-Z]/.test(key)) { } else {
        return event.preventDefault();
      }

    });
    let snombre = document.getElementById('segundo-nombre');
    snombre.addEventListener("keypress", function (event) {
      const key = event.key;
      if (/[a-zA-Z]/.test(key)) { } else {
        return event.preventDefault();
      }

    });
    let apellido = document.getElementById('primer-apellido');
    apellido.addEventListener("keypress", function (event) {
      const key = event.key;
      if (/[a-zA-Z]/.test(key)) { } else {
        return event.preventDefault();
      }

    });
    let sapellido = document.getElementById('segundo-apellido');
    sapellido.addEventListener("keypress", function (event) {
      const key = event.key;
      if (/[a-zA-Z]/.test(key)) { } else {
        return event.preventDefault();
      }

    });
    let celular = document.getElementById('phone');
    celular.addEventListener("keypress", function (event) {
      const key = event.key;
      if (/[0-9]/.test(key)) { } else {
        return event.preventDefault();
      }
    });
    celular.addEventListener('input', function () {
      if (this.value.length > 10)
        this.value = this.value.slice(0, 10);
    });
    let email = document.getElementById('correo-electrnico');
    email.addEventListener('input', function () {
      if (this.value.length > 100)
        this.value = this.value.slice(0, 100);
    });
  },
  async created() {
    const response = await config.listasDesplegables({
      "nombre_entidad": "listados",
    })
    
    console.log("respuesta listas desplegables", response);

    

    this.valoresperfil = response.find(item => item.data.nombre_lista === "perfiles").data.rows;
    this.schema.fields[10]['values'] = this.valoresperfil

    VueFormGenerator.validators.resources.fieldIsRequired = "Campo requerido"
    VueFormGenerator.validators.resources.invalidNumber = "Campo requerido"
    VueFormGenerator.validators.resources.textTooBig = "El campo permite hasta {1} caracteres."
    VueFormGenerator.validators.resources.numberTooBig = "Excediste el limite de digítos"
    VueFormGenerator.validators.resources.invalidTextContainNumber = "¡Texto no válido! No puede contener números ni caracteres especiales"
    VueFormGenerator.validators.resources.invalidEmail = "¡Dirección de correo electrónico no válida!"
    VueFormGenerator.validators.resources.thisNotText = "gg"

    const token = localStorage.getItem('userToken');
    try {
      const response = await config.datosPersonales({
        "token": token,
      });
      this.item = response[0];
      console.log("respuesta datos personales", response);
      this.model.pnombre = this.item.primer_nombre;
      this.model.snombre = this.item.segundo_nombre;
      this.model.papellido = this.item.primer_apellido;
      this.model.sapellido = this.item.segundo_apellido,
        this.model.tipo_identificacion.id = this.item.tipo_id;
      this.model.identificacion = this.item.numero_id;
      this.model.country = "+57";
      this.model.celular = this.item.celular;
      this.model.email = this.item.nombre_usuario;
      this.model.empresa.id = this.item.id_tenant;
      this.model.perfil.id = this.item.id_perfil;


    } catch (error) {
    }

  },
  methods: {
    validateName(value) {
      const regex = /^[a-zA-Z\s]*$/;
      if (!regex.test(value)) {
        this.model.pnombre = this.model.pnombre.replace(/[^a-zA-Z\s]/g, "");
      }
    },
    async remove(index) {

      this.company = await this.eliminarElementoYInicializar(this.company, index)


    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    disissDownChanged(disiss) {
      this.disiss = disiss
    },

    eliminarElementoYInicializar(arr, indice) {
      arr.splice(indice, 1); // Elimina el elemento en el índice especificado

      const nuevoArr = []; // Crea un nuevo objeto vacío

      for (let i = 0; i < arr.length; i++) {
        nuevoArr[i] = arr[i]; // Asigna los elementos del arreglo con las nuevas llaves
      }


      return nuevoArr;
    },

    handleKeypress(event) {
      if (this.identificationType == 'CC' | this.identificationType == 'TI' || this.identificationType == 'NI' || this.identificationType == 'NU') {

        if (e.key.match(/[0-9\s]/i) === null) {
          e.preventDefault();
        }
      } else {
        if (e.key.match(/[a-z0-9\s]/i) === null) {
          e.preventDefault();
        }
      }

    },
    async updateDatosPersonales() {

      var errors = this.$refs.newMemberForm.validate();


      if (errors == true) {
        this.load = true;
        this.equis = true;
        try {
          const response = await config.updateDatosPerfil({
            "id_usuario": this.item.id_usuario,
            "id_tipo_usuario": this.item.id_tipo_usuario,
            "modulo": 1,
            "tenant": this.item.id_tenant,
            "perfil": this.item.id_perfil,
            "tipo_id": this.item.tipo_id,
            "numero_id": this.model.identificacion,
            "primer_nombre": this.model.pnombre.toUpperCase(),
            "segundo_nombre": this.model.snombre.toUpperCase(),
            "primer_apellido": this.model.papellido.toUpperCase(),
            "segundo_apellido": this.model.sapellido.toUpperCase(),
            "celular": this.model.celular,
          });
          this.disiss = this.dis;
          this.load = false;
          setTimeout(() => {
            this.$router.go('/registro');
          }, 8000);




        } catch (error) {
          this.load = false;
          if (error.response.data.error.message == 'Error inesperado en user PostgresError: duplicate key value violates unique constraint "usuarios_nombre_usuario_key"') {
            this.dismissCountDown = this.dismissSecs;
            this.mensaje = "El correo ingresado ya se encuentra registrado"
          }

        }
      } else {
        this.equis = false;
      }
    }
  },
}
</script>
<style>
.fa,
.fas {
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
}

.form-group.disabled>label {
  color: #212529 !important;
  font-style: normal !important;
}

/* a continuación hay que poner la instrucción concreta de cada icono. fijaros que en realidad mediante el pseudo-selector ::before introducimos contenido delante de la etiqueta*/

.fa-thumbs-down:before {
  content: "\f165";
}

.nombre {
  transform: uppercase !important;
}

.alertared {
  margin-top: 2%;
}

.dele {
  color: white;
  background: var(--blue-violet);
  border-radius: 5px;
  zoom: 1.8;
  padding: 2%;
}

.hed {
  font-family: var(--font-family-poppins);

  padding: 1%;
  text-align: center;
}

.dato {
  border-top: 1px solid gainsboro;
}

.contenidotabla {
  background: white;
  margin: 0%;
  border-radius: 8px;
  border: 1px solid gainsboro;
  padding: 1%;
  margin-top: 3%;
}

.tabla {
  color: var(--blue-violet);
  font-weight: 600;
  border-bottom: 1px solid gainsboro;
}

.close {
  background: transparent;
  border: none;
  color: white;
  zoom: 1.5;
  margin-top: -0.6%;
  float: right;
}

.alert-dismissible {
  padding-right: 1rem !important;
}

.alert-danger {
  --bs-alert-color: white !important;
  --bs-alert-bg: red !important;
  --bs-alert-border-color: #f5c2c7;
  font-family: var(--font-family-poppins);
  font-size: 14px;
}

.icono {
  zoom: 2;
  margin-left: -32%;
  margin-top: -8%;

}

.vue-form-generator .hint {
  font-style: italic;
  font-size: 10px;
}

.has-error>.fiel-wrap {
  border: 1px solid red;
}

.errors {
  color: red;
  font-size: 11px !important;
}

.panel-body {
  margin: 2% 5%;
  font-family: var(--font-family-poppins);
}

.my-4 {
  color: var(--blue-violet);
}

.regis {
  font-size: 33px !important;
  text-align: center !important;
  font-weight: 600 !important;
  color: var(--blue-violet);
}

.regiss {
  font-size: 20px !important;
  text-align: left !important;
  font-weight: 800 !important;
  margin-bottom: 2%;
}

.centro {
  text-align: center;
}

hr {
  opacity: 1 !important;
}

.botonregidtro {
  width: 20%;
  margin-top: 2%;
  background-color: var(--blue-violet) !important;
  border-radius: 10px !important;
  height: 50px;
  border-color: transparent !important;
  border-color: transparent !important;
}

.botonadd {
  width: 50px;
  background-color: var(--blue-violet) !important;
  border-radius: 10px !important;
  height: 50px;
  border-color: transparent !important;
  border-color: transparent !important;
  position: absolute;
  right: 5%;
  top: 77%;
}</style>